import { sql } from "drizzle-orm";
import {
  boolean,
  index,
  integer,
  pgTable,
  serial,
  text,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { richText, timestamps } from "./shared";

const { createInsertSchema, createSelectSchema, createUpdateSchema } =
  createSchemaFactory({ zodInstance: z });

export const helpArticles = pgTable(
  "help_articles",
  {
    id: serial().primaryKey(),
    slug: text().notNull().unique(),
    title: text().notNull(),
    content: richText(),
    plaintext: text().notNull().default(""),
    tags: text().array().notNull().default([]),
    published: boolean().notNull().default(false),
    order: integer().notNull().default(0),
    ...timestamps,
  },
  (table) => [
    index("help_articles_search_idx").using(
      "gin",
      sql`(
        setweight(to_tsvector('english', coalesce(${table.title}, '')), 'A') ||
        setweight(to_tsvector('english', coalesce(${table.plaintext}, '')), 'B')
      )`,
    ),
  ],
);

export const selectHelpArticleSchema = createSelectSchema(helpArticles);
export const createHelpArticleSchema = createInsertSchema(helpArticles).omit({
  id: true,
  plaintext: true,
  createdAt: true,
  updatedAt: true,
});
export const updateHelpArticleSchema = createUpdateSchema(helpArticles).pick({
  slug: true,
  title: true,
  content: true,
  tags: true,
  published: true,
  order: true,
});

export type HelpArticle = z.infer<typeof selectHelpArticleSchema>;
export type CreateHelpArticle = z.infer<typeof createHelpArticleSchema>;
export type UpdateHelpArticle = z.infer<typeof updateHelpArticleSchema>;
